import { jsx as _jsx } from "react/jsx-runtime";
import { AspectRatio } from "../../../../aspect-ratio";
import { ImageWithHeadlineContainer, ImageContainer, } from "./ImageWithHeadline.styles";
import { Image } from "../image/image";
const aspectRatios = {
    s: {
        small: "16:9",
        medium: "1:1",
        large: "1:1",
        xlarge: "",
    },
    m: {
        small: "16:9",
        medium: "",
        large: "",
        xlarge: "",
    },
};
export function ImageWithHeadline({ image, imageTitle, size, hovered, altText, breakPoint, tileHeight, fallbackImg, backgroundColor, }) {
    const imageContainer = (_jsx(ImageContainer, Object.assign({ className: "image-container" }, { children: _jsx(Image, { title: imageTitle, alt: altText, src: image, fallbackSrc: fallbackImg, fallbackBackgroundColor: backgroundColor }) })));
    const ratio = aspectRatios[size][breakPoint];
    return (_jsx(ImageWithHeadlineContainer, Object.assign({ className: "image-container", tileHeight: tileHeight, hovered: hovered, size: size }, { children: ratio ? (_jsx(AspectRatio, Object.assign({ ratio: ratio }, { children: imageContainer }))) : (imageContainer) })));
}
